import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

export type CategoryAction = ActionType<typeof actions>;

/**
 * Action types
 */
export enum CategoryActionTypes {
  LOAD_REQUEST = '@category/LOAD_REQUEST',
  LOAD_SUCCCES = '@category/LOAD_SUCCCES',
  LOAD_FAILURE = '@category/LOAD_FAILURE',
  SET_SUBCATEGORIES = '@category/SUB_CATEGORIES',
  SET_CATEGORY_SELECTED = '@category/SET_CATEGORY_SELECTED',
  SET_SUBCATEGORY_SELECTED = '@category/SET_SUBCATEGORY_SELECTED',
  RESET_CATEGORIES_SELECTED = '@category/RESET_CATEGORIES_SELECTED',
  SEARCH_COMPONENTS = '@category/SEARCH_COMPONENTS',
  SEARCH_COMPONENTS_RESPONSE = '@category/SEARCH_COMPONENTS_RESPONSE',
  SEARCH_COMPONENTS_ALREADY_EXIST = '@category/SEARCH_COMPONENTS_ALREADY_EXIST',
}

export interface FindCategoryProps {
  id?: string;
  short_description?: string;
}

export interface CategoryData {
  id: string;
  short_description: string;
  open?: boolean;
  subcategories?: CategoryData[];
  root: boolean;
}

export interface Banner {
  id: number;
  title: string;
  description?: string;
  action?: {
    show_button?: number;
    button_title?: string;
    externalUrl?: string;
    category_id?: string[];
    subcategoryId?: number;
  };
  images: {
    web: string;
    mobile: string;
  };
}

export interface HeroBannerData {
    id: number;
    title: string;
    banners: Banner[];
    size: 'small' | 'medium' | 'big';
}

export interface ComponentsData {
  isLoading: boolean;
  categoryCurrentId: string;
  data: {
    [x: string]: HeroBannerData[],
  };
}

export interface CategoryState {
  readonly categorys: CategoryData[];
  readonly parent_id: string;
  readonly short_description: string;
  readonly subCategoriesSelected: CategoryData[];
  readonly categorySelected: string;
  readonly subCategorySelected: string;
  readonly filters: FindCategoryProps;
  readonly loading: boolean;
  readonly error: boolean;
  readonly components: ComponentsData;
}
